import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import chickenImg from "../../Assets/chicken.jpg";
import Tilt from "react-parallax-tilt";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              About <span className="purple">BESC LLC</span>
            </h1>
            <p className="home-about-body">
              Builders Edge Services & Construction (BESC LLC) is a trusted leader in the 
              construction and home improvement industry, specializing in high-quality 
              residential and commercial projects. With a commitment to excellence, we bring 
              our clients' visions to life through expert craftsmanship, innovative designs, 
              and a customer-first approach. From custom renovations to large-scale builds, 
              BESC LLC delivers unparalleled results.
              <br />
              <br />
              But we're more than just a construction company—we're{" "}
              <b className="purple">pioneers in merging traditional industries with blockchain technology</b>. 
              With the launch of our proprietary crypto coin and the Builders Exchange (CEX) platform, 
              we're revolutionizing how the construction and home improvement industry operates.
              <br />
              <br />
              <b className="purple">Why Choose BESC LLC?</b>
              <br />
              • Crypto Coin with Real Utility: Our coin enables seamless payments, rewards loyal 
              customers, and provides transparency for all projects through blockchain integration.
              <br />
              • Dividends for Holders: Coin and NFT holders receive regular dividends, sharing in 
              the success of our ecosystem.
              <br />
              • Exclusive Perks for Stakers: Stake your BESC on the Builders Exchange to unlock 
              special benefits, including:
              <br />
              &nbsp;&nbsp;&nbsp;- A share of transaction fees from the exchange
              <br />
              &nbsp;&nbsp;&nbsp;- Bonus coins from every Initial Coin Offering (ICO) that lists with us
              <br />
              • Secure and User-Friendly CEX: The Builders Exchange offers a safe, reliable platform 
              for trading, staking, and participating in the crypto economy.
              <br />
              <br />
              At BESC LLC, we're not just building homes and businesses—we're building a future where 
              construction meets cutting-edge technology. Whether you're renovating, investing, or trading, 
              BESC LLC is your partner for innovation and growth. Join us in shaping a smarter, more 
              connected world.
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img 
                src={chickenImg} 
                className="img-fluid" 
                alt="BESC LLC mascot" 
                style={{
                  borderRadius: "10px",
                  maxWidth: "100%",
                  height: "auto"
                }}
              />
            </Tilt>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Home2;
